import "./visuallyHidden_module.css";
const visuallyHidden_module = {
    visuallyHidden: "visuallyHidden__409675ecbc6a4e31"
};
export { visuallyHidden_module as default };
